import { HIDE_BUSINESS_INTERNAL_ID } from 'common/constants';
import { useHideSomeExperiment } from './use-hide-some-experiment';

export function useHideBusiness() {
  return useHideSomeExperiment(HIDE_BUSINESS_INTERNAL_ID);
}
